<template>
<div class="CapitalMgt">
    <keep-alive :include="includeList">
        <router-view :hostroletype="hostroletype" :hostroleinnerid="hostroleinnerid"></router-view>
    </keep-alive>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {initPage} from 'common/js/mixin'
export default {
    name: 'CapitalMgt',
    mixins: [initPage],
    data() {
        return {
            hostroletype: 2,
            hostroleinnerid: '',
            includeList: ['CapitalList', 'tobeSentCommission', 'WithdrawalList']
        }
    },
    mounted() {
        this.hostroleinnerid = this.brandBusiness.hostid
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['brandBusiness'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.CapitalMgt {
}
</style>
